import React from "react";
import {
  FaCalendarAlt,
  FaLayerGroup,
  FaRedo,
} from "react-icons/fa";

import { formatMonthLabel, getGroupName } from "../utils/attendanceUtils";

export default function AttendanceMonthToolbar({
  selectedGroup,
  selectedMonth,
  loading = false,
  onSelectMonth,
  onRefresh,
}) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-slate-950">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="min-w-0">
          <div className="inline-flex items-center gap-2 rounded-full bg-blue-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-blue-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaLayerGroup />
            Suivi mensuel
          </div>

          <h3 className="mt-3 truncate font-titre text-xl font-bold text-slate-950 dark:text-white">
            {getGroupName(selectedGroup)}
          </h3>

          <p className="mt-1 text-sm font-medium text-slate-500 dark:text-slate-400">
            Mois affiché :{" "}
            <span className="font-bold text-slate-700 dark:text-slate-200">
              {formatMonthLabel(selectedMonth)}
            </span>
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-[220px_auto]">
          <label className="block">
            <span className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
              <FaCalendarAlt />
              Mois
            </span>

            <input
              type="month"
              value={selectedMonth || ""}
              disabled={loading}
              onChange={(event) => onSelectMonth?.(event.target.value)}
              className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:ring-4 focus:ring-sky-100 disabled:opacity-60 dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
            />
          </label>

          <div className="flex items-end">
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-60"
            >
              <FaRedo className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}